import { render, staticRenderFns } from "./AnamnesiBotoxList.vue?vue&type=template&id=94d362c0"
import script from "./AnamnesiBotoxList.vue?vue&type=script&lang=js"
export * from "./AnamnesiBotoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports